export default {
  swap: {
    fees: 'Fees',
    rate: 'Rate',
    title: 'Swap',
    route: 'Route',
    youPay: 'You pay',
    youReceive: 'You receive',
    backToSwap: 'Back to Swap',
    enterAmount: 'Enter amount',
    maximumInput: 'Maximum Input',
    tolerance: 'Slippage Tolerance',
    minimumOutput: 'Minimum output',
    connectWallet: 'Connect Wallet',
    expectedOutput: 'Expected output',
    viewTransaction: 'View Transaction',
    advancedSettings: 'Advanced Settings',
    currentlyOffline: 'Currently offline',
    swapTime: 'Swap ({swapTimeRemaining}s)',
    somethingWentWrong: 'Something went wrong.',
    swappedSuccessfully: 'Swapped successfully!',
    rateExpired: 'Rate expired. Click to Update',
    swapAmountTooLow: 'The swap amount is too low',
    insufficientLiquidity: 'Insufficient Liquidity',
    pleaseTryAgain: 'Please reload page to try again.',
    tooltip:
      'Your transaction will be automatically cancelled if the price changes unfavorably by more than this percentage.',
    youHaveSwapped:
      'You have swapped {inputAmount} {inputTokenSymbol} to {outputAmount} {outputTokenSymbol}',
    priceWarning:
      'High slippage detected! Only proceed if you understand you might receive less {symbol} than anticipated.'
  }
}
